import {EventBus} from "../../../common/ts/events/EventBus";
import {PageLoadedEvent, SerpListingsUpdatedEvent, WhitelabelEvent} from "../../../common/ts/events/Events";
import {connect} from "../../../common/ts/connect";
import dom from "../../../common/ts/core/dom";
import GoogleAdsenseForSearch from "../../../modules/aggregators/ts/adsenseForSearch/GoogleAdsenseForSearch";
import GoogleDisplay, {SERP_PAGE} from "../advertising/googleDisplay"; // Fixme Move when unify display components
import SimilarToClickListingsService from "../serp/services/SimilarToClickListingsService";
import SimilarToClickListingsSubscriber from "../serp/subscribers/SimilarToClickListingsSubscriber";
import {ApiListingsRepository} from "../core/api/ApiRepository";
import CookieService from "../../../common/ts/services/CookieService";
import {CONSENT_COOKIE_NAME, DisclaimerCookie} from "../gdpr/DisclaimerCookie";
import EmailCaptureOrchestrator from "./serp/emailCapture/EmailCaptureOrchestrator";
import {setInteractionFlag} from "./SerpInteraction";
import {WPNManager} from "../wpn/WPNManager";
import {WPNEventHandlers} from "../wpn/WPNEventHandlers";

const eventBus: EventBus = EventBus.getInstance();
eventBus.subscribeWithId(
    PageLoadedEvent.TYPE,
    {
        id: 'nestoria-serp-page-loaded-subscriber',
        callback: onSerpPagePageLoad
    }
);

function onSerpPagePageLoad(event: WhitelabelEvent): void {
    const publicVapidKey = 'BPmq6GEKK3iyoIZuXqAEmPMlukYdFTXm8NmqsQmQlxZA8Xb-RIj4uGVeIWSS3inXbpmxhvptfdHJSrILUW2o4CI'
    const swScriptUrl = '/sw.js'
    connect(() => {
        dom.init();
        const googleAfs = new GoogleAdsenseForSearch(window._googCsa, dom)
        googleAfs.init();
        new GoogleDisplay(window.googletag, dom).init(SERP_PAGE)
        if (!CookieService.exists(CONSENT_COOKIE_NAME)) {
            new DisclaimerCookie();
        }

        const listingsRepository = new ApiListingsRepository();
        const similarToClickListingsService = new SimilarToClickListingsService(eventBus, listingsRepository);
        const similarToClickListingsSubscriber = new SimilarToClickListingsSubscriber(eventBus, similarToClickListingsService);
        similarToClickListingsSubscriber.init();

        const emailCaptureOrchestrator = new EmailCaptureOrchestrator();
        emailCaptureOrchestrator.init();

        initClickableSnippets();
        initInfoToggleButtons();
        initPaginationInteractionTracking();

        eventBus.subscribeWithId(SerpListingsUpdatedEvent.TYPE, {
            id: 'nestoria-serp-clickable-snippets-subscriber',
            callback: () => {
                initClickableSnippets();
                initInfoToggleButtons();
            }
        });

        new WPNEventHandlers(eventBus).init();
        new WPNManager(
            publicVapidKey,
            swScriptUrl,
            eventBus
        ).init();
    });
}

function initClickableSnippets(): void {
    const snippets = document.querySelectorAll('.js-snippet-clickable:not([data-click-initialized])');
    snippets.forEach((snippet) => {
        snippet.setAttribute('data-click-initialized', 'true');
        snippet.addEventListener('click', (event: Event) => {
            const target = event.target as HTMLElement;
            if (target.closest('.js-property-cta')) {
                return;
            }
            const href = snippet.getAttribute('data-href');
            if (href) {
                const propertyCta = snippet.querySelector('.js-property-cta') as HTMLElement;
                if (propertyCta) {
                    propertyCta.dispatchEvent(new MouseEvent('click', {bubbles: true}));
                }
                window.open(href, '_blank');
            }
        });
    });
}

function initInfoToggleButtons(): void {
    document.querySelectorAll('.js-info-toggle:not([data-toggle-initialized])').forEach(button => {
        button.setAttribute('data-toggle-initialized', 'true');
        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const infoGroup = button.closest('.property-info-group');
            if (infoGroup) {
                infoGroup.classList.add('transitioning-white');
                setTimeout(() => {
                    infoGroup.classList.remove('transitioning-white');
                    infoGroup.classList.add('show-description');
                }, 300);
            }
        });
    });

    document.querySelectorAll('.js-info-back:not([data-back-initialized])').forEach(button => {
        button.setAttribute('data-back-initialized', 'true');
        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const infoGroup = button.closest('.property-info-group');
            if (infoGroup) {
                infoGroup.classList.remove('show-description');
                infoGroup.classList.add('transitioning-white');
                setTimeout(() => {
                    infoGroup.classList.remove('transitioning-white');
                }, 500);
            }
        });
    });
}

function initPaginationInteractionTracking(): void {
    const paginationLinks = document.querySelectorAll('.pagination a:not([data-interaction-initialized])');
    paginationLinks.forEach((link) => {
        link.setAttribute('data-interaction-initialized', 'true');
        link.addEventListener('click', () => {
            setInteractionFlag('pagination');
        });
    });
}
